import DATATABLE_TRANSLATIONS from "./datatable_translations";

export default class CourseEndReasonsDataTable {
  constructor() {
    $(document).ready(function() {
      showCourseEndReasonsTable();
    });

    $(document).on("turbo:render", function() {
      showCourseEndReasonsTable();
    });

    function showCourseEndReasonsTable() {
      $('#course-end-reasons-datatable').dataTable({
        "order": [],
        "columnDefs": [ {
          "targets"  : 'no-sort',
          "orderable": false,
        }],
        "language": DATATABLE_TRANSLATIONS,
        "processing": true,
        "serverSide": true,
        "ajax": {
          "url": $('#course-end-reasons-datatable').data('source')
        },
        "pagingType": "full_numbers",
        "columns": [
          {"data": "name"},
          {"data": "active"},
          {"data": "actions"}
        ]
        // pagingType is optional, if you want full pagination controls.
        // Check dataTables documentation to learn more about
        // available options.
      });
    }
  }
}
